import ExtractToEmailModal from './ExtractToEmailModal';

export default ExtractToEmailModal;
